import { autoDarkColors } from "@/modules/theme/color/darkModeColor.ts";
import type { ThemeProps, ThemeVarGetters, ThemeVariant } from "@/modules/theme/types.ts";

import png from "@/styles/warren/apple-touch-icon.png?url";
import icon from "@/styles/warren/favicon.ico?url";
import favicon from "@/styles/warren/favicon.svg?url";
import loginImage from "@/styles/warren/login-image.svg";
import loginLogo from "@/styles/warren/logo-dark.svg";
import logoDark from "@/styles/warren/logo-dark.svg?url";
import logo from "@/styles/warren/logo.svg?url";

export function makeTheme(variant: ThemeVariant) {
    const { isDark } = variant;

    const baseColors: ThemeVarGetters = autoDarkColors({
        "color-primary": "#006DFF",
        "color-secondary": "#e5e5e5",
    });

    return {
        ...baseColors,

        "logo-image": isDark ? `url("${logoDark}")` : `url("${logo}")`,

        "header-logo-width": "108px",
        "header-logo-height": "16px",

        //#region Login
        "login-body-bg-color": "var(--color-text)",
        "login-body-bg-size": "cover",
        "login-body-text-color": "var(--color-white)",
        "login-justify-content": "space-between",
        "login-align-items": "stretch",

        "login-intro-display": "flex",
        "login-intro-bg-image": "",
        "login-intro-bg-size": "cover",
        "login-intro-bg-position": "50% 50%",
        "login-intro-text-align": "center",
        "login-intro-flex-direction": "column",
        "login-intro-justify-content": "center",
        "login-intro-align-items": "center",
        "login-intro-padding": "80px",
        "login-title-font-size": "36px",
        "login-title-text-color": "",
        "login-title-font-weight": 300,
        "login-title-line-height": 1,
        "login-title-max-width": "450px",
        "login-title-padding": "20px 0 6px 0",
        "login-subtitle-font-size": "21px",
        "login-subtitle-max-width": "",

        "login-form-title-font-size": "30px",
        "login-form-input-bg-color": "#FFFFFF",
        "login-form-bg-color": "var(--color-text)",
        "login-form-text-color": "var(--color-white)",
        "login-form-border-left": "#32323B solid 1px",
        "login-form-button-border-radius": "var(--button-border-radius)",
        "login-form-or-text-color": "var(--color-white)",
        "login-form-or-border-color": "#00488B",
        "login-form-google-bg-color": "#D9524F",
        "login-form-more-text-color": "var(--color-white)",
        "login-form-more-bg-color": "transparent",
        "login-form-more-border-color": "var(--color-primary)",
        //#endregion
    } satisfies ThemeVarGetters;
}

export const props: ThemeProps = {
    favicon,
    icon,
    png,
    loginLogoImg: {
        src: loginLogo,
        style: {
            maxWidth: "200px",
        },
    },
    loginIntroImg: {
        src: loginImage,
        style: {
            maxWidth: "142px",
        },
    },
};
